import React, { Component, Fragment } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Container
} from "reactstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import logo from "../images/truman-logo.png";
import Logout from "../components/auth/Logout";

class AppNavbar extends Component {
  state = {
    isOpen: false
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  static propTypes = {
    auth: PropTypes.object.isRequired
  };

  render() {
    const navbar = { backgroundColor: "#691b95" };

    const { isAuthenticated, user } = this.props.auth;

    let loggeduser = " ";
    if (user && user[0].username) {
      loggeduser = `Welcome ${user[0].username}`;
    } else {
      loggeduser = "Welcome";
    }

    const authLinks = (
      <Fragment>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <span className="navbar-text mr-1">
                <strong> {loggeduser} </strong>
              </span>
            </NavItem>
            <NavItem>
              <Logout />
            </NavItem>
          </Nav>
        </Collapse>{" "}
      </Fragment>
    );
    return (
      <div>
        <Navbar expand="sm" className="mb-5" style={navbar}>
          <Container>
            <NavbarBrand href="https://www.truman.edu/">
              {" "}
              <div className="container">
                <div className="row mb-5">
                  <div className="col">
                    {" "}
                    <img alt={"Truman State University"} src={logo} />{" "}
                  </div>
                  <div className="col">
                    {" "}
                    <h2
                      style={{
                        color: "white"
                      }}>
                      Organizations
                    </h2>{" "}
                  </div>
                </div>
              </div>
            </NavbarBrand>
            {isAuthenticated ? authLinks : ""}
          </Container>
        </Navbar>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  {}
)(AppNavbar);
